
    import { defineComponent, PropType } from 'vue';

    export default defineComponent({
        name: "ValidationMessages",
        props: {
            messages: { type: Object as PropType<string[]>, required: false, default: null }
        },
        computed: {
            hasMessages(): boolean {
                return this.messages?.length > 0;
            }
        }
    });
